import { rememberReminderDismissed } from "@/utils/passwordDeadline";

// "Update your password" popup. The flag comes from the API
// (must_change_password in login / profile answers, or a 423 password_change_required).
// Before the deadline it is a dismissible reminder (enforced = false); from the
// deadline on it blocks (enforced = true).
export default {
    state: () => ({
        required: false,
        enforced: false,
        deadline: null,
    }),
    getters: {
        isRequired(state) {
            return state.required;
        },
        isEnforced(state) {
            return state.enforced;
        },
        deadline(state) {
            return state.deadline;
        },
    },
    mutations: {
        setRequired(state, required) {
            state.required = required;
        },
        setMode(state, {enforced, deadline}) {
            // A reminder that is already open can only get stricter (a 423 arrives
            // once the deadline passes), never softer.
            state.enforced = state.enforced || !!enforced;
            if (deadline !== undefined) {
                state.deadline = deadline;
            }
        },
    },
    actions: {
        // Idempotent: parallel requests that all get a 423 just keep it open.
        require({state, commit}, {enforced = true, deadline} = {}) {
            commit('setMode', {enforced, deadline});
            if (state.required) {
                return;
            }
            document.body.classList.add('body-scroll-hidden');
            commit('setRequired', true);
        },
        // "Later" on the reminder: not shown again until tomorrow.
        dismiss({dispatch}) {
            rememberReminderDismissed();
            dispatch('done');
        },
        done({commit}) {
            document.body.classList.remove('body-scroll-hidden');
            commit('setRequired', false);
        },
    },
    namespaced: true,
};
